import { Component, inject, input, OnInit, signal } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { RouteCodeEnum } from '@models/menu';

import { BaseRestrictions } from '@models/module/fields/enums';
import { NutrientComponent, NutrientDialogData } from '@module-definition/nutrient/nutrient.component';
import { PdfMarkupModel, PdfMarkupService } from '@module-instance/pdf-markups/common';
import { CipoTableOptions, DisplayFormats, TableColumn, TableRow } from '@shared/components/data-list/common';
import { DataListModule } from '@shared/components/data-list/data-list.module';
import { PAGE_SIZE_OPTIONS } from '@shared/consts';
import { UserService } from '@shared/services/user.service';
import { UserStore } from '@signal-store/user.store';

type PdfMarkupRow = TableRow & PdfMarkupModel;

@Component({
  selector: 'cipo-pdf-markup-tab',
  imports: [DataListModule],
  templateUrl: './pdf-markup-tab.component.html',
  providers: [PdfMarkupService],
})
export class PdfMarkupTabComponent implements OnInit {
  private pdfMarkupService = inject(PdfMarkupService);
  private dialog = inject(MatDialog);
  private userService = inject(UserService);
  private userStore = inject(UserStore);

  entityInstanceId = input.required<number>();
  tableData = signal<PdfMarkupRow[]>(undefined);
  tableOptions: CipoTableOptions<any, PdfMarkupRow> = {
    clickableRows: true,

    pagination: {
      pageSize: PAGE_SIZE_OPTIONS.default[0],
      pageSizeOptions: PAGE_SIZE_OPTIONS.default,
    },
  };

  tableColumns: TableColumn[] = [
    {
      id: 0,
      name: 'name',
      sortable: true,
      displayName: 'pdfMarkups.docTable.name',
    },
    {
      id: 0,
      name: 'createdBy',
      sortable: true,
      displayName: 'pdfMarkups.docTable.createdBy',
    },
    {
      id: 0,
      name: 'createdOn',
      sortable: true,
      displayName: 'pdfMarkups.docTable.createdOn',
      displayFormatId: DisplayFormats.Date,
      restrictions: BaseRestrictions.DateTime,
    },
  ];

  ngOnInit(): void {
    this.pdfMarkupService.getDocumentMarkups(this.entityInstanceId()).subscribe(markups => {
      this.tableData.set(markups.map(markup => markup as PdfMarkupRow));
    });
  }

  openPdfMarkup(markup: PdfMarkupRow): void {
    const documents = [
      {
        versionId: markup.fileVersionId,
        name: markup.name,
      },
    ];
    this.dialog.open<NutrientComponent, NutrientDialogData>(NutrientComponent, {
      panelClass: ['cipo-dialog', 'classic', 'cipo--height--full'],
      ...this.userService.getResponsiveDialogSize().xl,
      data: {
        documents,
        isMarkup: true,
        documentId: markup.documentId,
        entityInstanceId: markup.entityInstanceId,
        fileId: markup.fileId,
        moduleId: this.userStore.getModuleByCode(RouteCodeEnum.FileContractManager)?.moduleId,
      },
    });
  }
}
